"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

/**
 * 生成符合无极api的基础查询条件字符串
 * 1、sortCon、pageCon
 * @param queryBaseList 单个表的除字段外的基础查询条件
 */
var queryBaseParse = function queryBaseParse(queryBaseList) {
  var isCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var list = [];
  queryBaseList.forEach(function (item) {
    if (isCount && (item.key === 'page' || item.key === 'size')) {
      return;
    }

    list.push("".concat(item.key).concat(item.optType).concat(item.value));
  });

  if (list.length > 0) {
    return list.join('&');
  }

  return '';
};
/**
 * 生成符合无极api的数据过滤条件字符串
 * @param queryFilterList 表字段的数据过滤条件[无极接口的数据过滤]
 */


var queryFilterParse = function queryFilterParse(queryFilterList) {
  var list = [];
  queryFilterList.forEach(function (item) {
    list.push("".concat(item.key).concat(item.optType).concat(item.value));
  });

  if (list.length > 0) {
    return "filter=".concat(encodeURIComponent(list.join('&')));
  }

  return '';
};
/**
 * 单个表的无极api请求参数生成入口
 * @param table dataManager的表对象
 */


function _default(table) {
  var isCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var queryFilterList = table.queryFilterList,
      queryRelationList = table.queryRelationList,
      queryBaseList = table.queryBaseList; // 两者的查询条件处理一致，合并处理

  var queryFilter = queryFilterParse(queryFilterList.concat(queryRelationList));
  var queryBase = queryBaseParse(queryBaseList, isCount);

  if (queryBase || queryFilter) {
    return "&".concat(queryBase).concat(queryBase && queryFilter ? '&' : '').concat(queryFilter);
  }

  return '';
}